import React, { useEffect, useState } from "react";
import PartOne from "./partOne";
import PartTwo from "./partTwo";
import Notes from "../notes/notes";
import PartThree from "./partThree";
import Credit from "./credit";
import Form from "react-bootstrap/Form";
import Headings from "../../../constants/headings";
import { Row } from "react-bootstrap";
const Index = (props) => {

  return (
    <Form className="pb-5 user-info-from">
      {props.customer && (
        <>
          <Row className="row-reverse">
            <Credit credit={props.customer.Credit}></Credit>
          </Row>
          <Row>
            <h2>{Headings.UserInfoTitlePartOne}</h2>
            <PartOne
              isEditMood={props.isEditMood}
              customer={props.customer}
              editInfo={props.editInfo}
              setEditInfo={props.setEditInfo}
            ></PartOne>
            <h2>{Headings.UserInfoTitlePartTwo}</h2>
            <PartTwo
              key={props.isEditMood}
              customer={props.customer}
              token={props.token}
              userId={props.userId}
              isEditMood={props.isEditMood}
              setEditInfo={props.setEditInfo}
              editInfo={props.editInfo}
              setisValidEdit={props.setisValidEdit}
              postalCodeVliad={props.postalCodeVliad }
              setPostalCodeVliad={props.setPostalCodeVliad}
              houseNumberVliad={ props.houseNumberVliad}
              setHouseNumberVliad={props.setHouseNumberVliad}
            ></PartTwo>
            <h2>{Headings.UserInfoTitlePartTHree}</h2>
            <PartThree customer={props.customer}></PartThree>
            <h2>{Headings.NotesTitle}</h2>
            <Notes
              token={props.token}
              userId={props.userId}
            ></Notes>
          </Row>
        </>
      )}
    </Form>
  );
};
export default Index;
